/**
 * ContactHero section
 */
(function contactHeroFrontend($) {
	$(document).on('cms.ready', ready);

	function ready() {
		var logged_in = $('body.logged-in').length;

		if (logged_in) {
			$(document).on('cms.intersect', '.sectionContactHero', function (evt, entry, $elm) {
				setupSection(0, $elm);
			});
		}

		$('.sectionContactHero').each(setupSection);

		$(window).on('resize.contactHeroMeta', function () {
			$('.sectionContactHero').each(function () {
				fitHeroMeta($(this));
			});
		});
	}

	function setupSection(i, elm) {
		var $elm = $(elm);
		if ($elm.data('contact-hero-ready')) return;
		$elm.data('contact-hero-ready', true);

		var $wave = $elm.find('.contact-hero__waves img');
		if ($wave.data('anim')) {
			$wave.attr('src', $wave.data('anim'));
		}

		if (window.Contenda && Contenda.company) {
			Contenda.company.fillContact($elm);
			$elm.find('.js-hero-meta').text(Contenda.company.heroMeta());
			var open = Contenda.company.isOpen();
			$elm.find('.js-open-status')
				.toggleClass('is-open', open)
				.toggleClass('is-closed', !open);
		}

		setupVideo($elm.find('.contact-hero__video').get(0));
		requestAnimationFrame(function () {
			fitHeroMeta($elm);
		});
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(function () {
				fitHeroMeta($elm);
			});
		}
	}

	function fitHeroMeta($hero) {
		var meta = $hero.find('.contact-hero__meta').get(0);
		if (!meta) return;
		meta.style.fontSize = '';
		var size = parseFloat(window.getComputedStyle(meta).fontSize) || 16;
		var min = 11;
		while (meta.scrollWidth > meta.clientWidth + 1 && size > min) {
			size -= 0.25;
			meta.style.fontSize = size + 'px';
		}
	}

	function setupVideo(video) {
		if (!video) return;
		var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		var saveData = navigator.connection && navigator.connection.saveData;
		if (reduce || saveData) {
			video.remove();
			return;
		}

		video.play().catch(function () {});
		if ('IntersectionObserver' in window) {
			new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting && !document.hidden) video.play().catch(function () {});
					else video.pause();
				});
			}, { threshold: 0.05 }).observe(video);
		}
		document.addEventListener('visibilitychange', function () {
			if (document.hidden) video.pause();
			else video.play().catch(function () {});
		});
	}
})(jQuery);
